import { normalize } from 'normalizr'
import { category } from '../adapters/categorySchema'
import { organization } from '../adapters/organizationSchema'
import { rate } from '../adapters/hwRateSchema'
import * as ActionTypes from './actionTypes'

// categories actions
export const hw_fetchCategoriesSuccess = data => ({
    type: ActionTypes.HW_CATEGORIES_FETCH_SUCCESS,
    ...data
})

export const hw_fetchCategoriesFailure = error => ({
    type: ActionTypes.HW_CATEGORIES_FETCH_FAILURE,
    error
})

export const hw_saveCategoriesSuccess = data => ({
    type: ActionTypes.HW_CATEGORIES_SAVE_SUCCESS,
    data: normalize(data, category)
})

export const hw_saveCategoriesFailure = error => ({
    type: ActionTypes.HW_CATEGORIES_SAVE_FAILURE,
    error
})

export const hw_deleteCategorySuccess = id => ({
    type: ActionTypes.HW_CATEGORIES_DELETE_SUCCESS,
    data: id
})

export const hw_deleteCategoryFailure = error => ({
    type: ActionTypes.HW_CATEGORIES_DELETE_FAILURE,
    error
})

export const hw_importCategoriesSuccess = data => ({
    type: ActionTypes.HW_CATEGORIES_IMPORT_SUCCESS,
    ...data
})

export const hw_importCategoriesFailure = error => ({
    type: ActionTypes.HW_CATEGORIES_IMPORT_FAILURE,
    error
})

// organizations actions
export const hw_fetchOrganizationsSuccess = data => ({
    type: ActionTypes.HW_ORGANIZATIONS_FETCH_SUCCESS,
    ...data
})

export const hw_fetchOrganizationsFailure = error => ({
    type: ActionTypes.HW_ORGANIZATIONS_FETCH_FAILURE,
    error
})

export const hw_saveOrganizationsSuccess = data => ({
    type: ActionTypes.HW_ORGANIZATIONS_SAVE_SUCCESS,
    data: normalize(data, organization)
})

export const hw_updateOrganizationsFailure = error => ({
    type: ActionTypes.HW_ORGANIZATIONS_UPDATE_FAILURE,
    error
})

export const hw_updateOrganizationsSuccess = data => ({
    type: ActionTypes.HW_ORGANIZATIONS_UPDATE_SUCCESS,
    data: normalize(data, organization)
})

export const hw_deleteOrganizationSuccess = id => ({
    type: ActionTypes.HW_ORGANIZATIONS_DELETE_SUCCESS,
    data: id
})

export const hw_deleteOrganizationFailure = error => ({
    type: ActionTypes.HW_ORGANIZATIONS_DELETE_FAILURE,
    error
})

export const hw_saveOrganizationsFailure = error => ({
    type: ActionTypes.HW_ORGANIZATIONS_SAVE_FAILURE,
    error
})

// rates actions
export const hw_fetchRatesSuccess = data => ({
    type: ActionTypes.HW_RATES_FETCH_SUCCESS,
    ...data
})

export const hw_fetchRatesFailure = error => ({
    type: ActionTypes.HW_RATES_FETCH_FAILURE,
    error
})

export const hw_saveRatesSuccess = data => ({
    type: ActionTypes.HW_RATES_SAVE_SUCCESS,
    data: normalize(data, rate)
})

export const hw_saveRatesFailure = error => ({
    type: ActionTypes.HW_RATES_SAVE_FAILURE,
    error
})

export const hw_deleteRateSuccess = id => ({
    type: ActionTypes.HW_RATES_DELETE_SUCCESS,
    data: id
})

export const hw_deleteRateFailure = error => ({
    type: ActionTypes.HW_RATES_DELETE_FAILURE,
    error
})

// currentOrganization actions
export const hw_changeCurrentOrganization = id => ({
    type: ActionTypes.HW_CURRENT_ORGANIZATION_CHANGE,
    data: id
})

// sync actions
export const hw_pushYearPricesRequest = () => ({
    type: ActionTypes.HW_PUSH_YEAR_PRICES_REQUEST
})
export const hw_pushYearPricesSuccess = () => ({
    type: ActionTypes.HW_PUSH_YEAR_PRICES_SUCCESS
})
export const hw_pushYearPricesFailure = () => ({
    type: ActionTypes.HW_PUSH_YEAR_PRICES_FAILURE
})

export const hw_checkAndPullOrdersRequest = () => ({
    type: ActionTypes.HW_CHECK_AND_PULL_ORDERS_REQUEST
})
export const hw_checkAndPullOrdersSuccess = () => ({
    type: ActionTypes.HW_CHECK_AND_PULL_ORDERS_SUCCESS
})
export const hw_checkAndPullOrdersFailure = () => ({
    type: ActionTypes.HW_CHECK_AND_PULL_ORDERS_FAILURE
})

export const hw_inventoryAvailabilityRequest = () => ({
    type: ActionTypes.HW_INVENTORY_AVAILABILITY_REQUEST
})
export const hw_inventoryAvailabilitySuccess = () => ({
    type: ActionTypes.HW_INVENTORY_AVAILABILITY_SUCCESS
})
export const hw_inventoryAvailabilityFailure = () => ({
    type: ActionTypes.HW_INVENTORY_AVAILABILITY_FAILURE
})

// easyms
export const hw_fetchEasymsCategoriesSuccess = data => ({
    type: ActionTypes.HW_EASYMS_CATEGORIES_FETCH_SUCCESS,
    payload: { ...data }
})
export const hw_fetchEasymsCategoriesFailure = error => ({
    type: ActionTypes.HW_EASYMS_CATEGORIES_FETCH_FAILURE,
    payload: { error }
})
export const hw_fetchEasymsRatesSuccess = data => ({
    type: ActionTypes.HW_EASYMS_RATES_FETCH_SUCCESS,
    payload: { ...data }
})
export const hw_fetchEasymsRatesFailure = error => ({
    type: ActionTypes.HW_EASYMS_RATES_FETCH_FAILURE,
    payload: { error }
})


// WEBPACK FOOTER //
// ./src/actions/hostelWorldActions.js